import Mask from "@/components/Mask/Mask";
// import { withPublicPath } from "@/utils";
import React from "react";
import styles from "./index.module.scss";
import useEffectStore from "@/stores/effectStore";
import FtLoading2 from "@/components/ft-loading/index2";
import FitSize from "@/components/fit-size/fit-size";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";

export default function MainLoadingPage() {
  const blobUrl = useEffectStore(
    (state) => state.fileOptions.uploadFile?.blobUrl
  );
  const width = useEffectStore((state) => state.fileOptions.width);
  const height = useEffectStore((state) => state.fileOptions.height);
  const { t } = useTranslation();
  const [title, setTitle] = React.useState("");
  useEffect(() => {
    let index = 1;
    setTitle(t(`img_loading_title_${index}`));
    const interval = setInterval(() => {
      index++;
      if (index >= 5) {
        index = 1;
      }
      setTitle(t(`img_loading_title_${index}`));
    }, 2000);
    return () => {
      clearInterval(interval);
    };
  }, []);
  return (
    <div className={styles.loading_wrapper}>
      <FitSize childrenHeight={height || 1} childrenWidth={width || 1}>
        <Mask url={blobUrl} />
        <FtLoading2 title={title} desc={""} className={styles.loading_img} />
      </FitSize>
    </div>
  );
}
